//GLOBAL - components from npm
import React from "react";

//STYLES
import "./h4.css";

//COMPONENTS

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...

export default function H4({ className, children, weight, color }) {
  //GENERAL
  const mainClassName = "typography-h4";

  //STATES

  //REDUX - Selectors

  //FUNCTIONS

  //USE EFFECTS

  return (
    <h4
      className={`${mainClassName} ${className ? className : ""} ${
        weight ? `${mainClassName}--${weight}` : ""
      } ${color ? `${mainClassName}--color-${color}` : ""}`}
    >
      {children}
    </h4>
  );
}
